/*
 * @Description: 报名
 * @Author: 山淑兰
 * @Date: 2019-12-17 11:06:41
 * @LastEditTime: 2020-05-26 18:35:30
 * @LastEditors: 山淑兰
 */
import { Get, Post, Pick } from "@/api/utils";
import {
  GetSignupConfig,
  ISendMsg,
  IMobileReg,
  IQuerySignRemaining,
  IGetSignMeetingUser,
  ICheckMeetingUserSign,
  IPostSignMeetingUser,
  IGetSignMeetingUserByMu,
  IVerWxLogin,
} from "./index.dto";

// const { API_HOST } = G_CONFIG;
const API_HOST = "";

export const SignupPath = {
  Init_SignConfig: API_HOST + "/api/MeetingSign/InitSignConfig", //报名页配置接口
  AccessTemp: API_HOST + "/api/Ver/AccessTemp", //获取非微信客户端临时Token
  SendMsg: API_HOST + "/api/Ver/SendMsg", //发送短信验证码
  SendVioceMsg: API_HOST + "/api/Ver/SendVioceMsg", //发送语音验证码
  MobileReg: API_HOST + "/api/Ver/MobileReg", //登录
  VerWxLogin: API_HOST + "/api/Ver/VerWxLogin", //微信授权登录获取token
  QuerySignRemaining: API_HOST + "/api/MeetingSign/QuerySignRemaining", //查询余票接口
  GetSignMeetingUser: API_HOST + "/api/MeetingSign/GetSignMeetingUser", //获取用户报名信息接口
  CheckMeetingUserSign: API_HOST + "/api/MeetingSign/CheckMeetingUserSign", //检查用户是否报名接口
  PostSignMeetingUser: API_HOST + "/api/MeetingSign/PostSignMeetingUser", //提交报名数据接口
  GetSignMeetingUserByMu: API_HOST + "/api/MeetingSign/GetSignMeetingUserByMu", //获取当前登录账户报名信息接口
};
export default {
  /**
   * @title 报名配置
   * @date 2019-12-27
   */
  InitSignConfig(body: GetSignupConfig) {
    const params = Pick(body, GetSignupConfig);
    return Get({
      url: SignupPath.Init_SignConfig,
      params,
    });
  },
  /**
   * @title 获取临时Token
   * @date 2019-12-27
   */
  AccessTemp() {
    return Post({
      url: SignupPath.AccessTemp,
    });
  },
  /**
   * @title 获取验证码
   * @date 2020-01-06
   */
  SendMsg(body: ISendMsg) {
    const params = Pick(body, ISendMsg);
    return Post({
      url: SignupPath.SendMsg,
      params,
    });
  },
  /**
   * @title 获取语音验证码
   * @date 2020-01-06
   */
  SendVioceMsg(body: ISendMsg) {
    const params = Pick(body, ISendMsg);
    return Post({
      url: SignupPath.SendVioceMsg,
      params,
    });
  },
  /**
   * @title 登录注册接口
   * @date 2020-01-06
   */
  MobileReg(body: IMobileReg) {
    const params = Pick(body, IMobileReg);
    return Post({
      url: SignupPath.MobileReg,
      params,
    });
  },
  /**
   * @title 查询余票接口
   * @date 2019-12-27
   */
  QuerySignRemaining(body: IQuerySignRemaining) {
    const params = Pick(body, IQuerySignRemaining);
    return Get({
      url: SignupPath.QuerySignRemaining,
      params,
    });
  },
  /**
   * @title 获取用户报名信息接口
   * @date 2020-1-13
   */
  GetSignMeetingUser(body: IGetSignMeetingUser) {
    const params = Pick(body, IGetSignMeetingUser);
    return Post({
      url: SignupPath.GetSignMeetingUser,
      params,
    });
  },
  /**
   * @title 检查用户是否报名接口
   * @date 2020-1-13
   */
  CheckMeetingUserSign(body: ICheckMeetingUserSign) {
    const params = Pick(body, ICheckMeetingUserSign);
    return Get({
      url: SignupPath.CheckMeetingUserSign,
      params,
    });
  },
  /**
   * @title 提交报名数据接口
   * @date 2020-01-15
   */
  PostSignMeetingUser(body: IPostSignMeetingUser) {
    const params = Pick(body, IPostSignMeetingUser);

    return Post({
      url: SignupPath.PostSignMeetingUser,
      params: body,
    });
  },
  /**
   * @title 获取当前登录账户报名信息接口
   * @date 2020-01-16
   */
  GetSignMeetingUserByMu(body: IGetSignMeetingUserByMu) {
    const params = Pick(body, IGetSignMeetingUserByMu);
    return Get({
      url: SignupPath.GetSignMeetingUserByMu,
      params,
    });
  },
  /**
   * @title 微信授权登录获取token接口
   * @date 2026-08-27
   */
  VerWxLogin(body: IVerWxLogin) {
    const params = Pick(body, IVerWxLogin);
    return Post({
      url: SignupPath.VerWxLogin,
      params,
    });
  },
};
